import React, { ReactNode } from 'react';
import clsx from 'clsx';
import css from './WizardStepFooter.module.css';
import { StackedColumn, TextButton } from '../../../../../core';

export interface WizardStepFooterProps {
  narrowWidth: boolean;
  continueText?: string;
  mayBeSticky: boolean;
  specialFooter?: ReactNode;
  onContinue?: () => void;
}

const WizardStepFooter: React.FC<WizardStepFooterProps> = (
  props: WizardStepFooterProps
) => {
  return (
    <>
      {props.onContinue || props.specialFooter ? (
        <div className={clsx(css.footer)}>
          <StackedColumn>
            <div
              className={clsx(
                props.narrowWidth && props.mayBeSticky
                  ? css.horizontalLine
                  : null
              )}
            />
            {props.specialFooter ?? null}
            {props.onContinue ? (
              <div
                className={clsx(props.narrowWidth ? null : css.buttonContainer)}
              >
                <TextButton
                  caption={props.continueText ?? 'Continue'}
                  onClick={props.onContinue}
                />
              </div>
            ) : null}
          </StackedColumn>
        </div>
      ) : null}
    </>
  );
};

export default WizardStepFooter;
